"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const AggregationExecutor_1 = __importDefault(require("../lib/AggregationExecutor"));
const GraphandFieldBoolean_1 = __importDefault(require("../lib/fields/GraphandFieldBoolean"));
const GraphandFieldJSON_1 = __importDefault(require("../lib/fields/GraphandFieldJSON"));
const GraphandFieldNumber_1 = __importDefault(require("../lib/fields/GraphandFieldNumber"));
const GraphandFieldScope_1 = __importDefault(require("../lib/fields/GraphandFieldScope"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
const GraphandModelPromise_1 = __importDefault(require("../lib/GraphandModelPromise"));
/**
 * @class Aggregation
 * @augments GraphandModel
 * @classdesc Aggregation model. Use {@link GraphandClient#getModel client.getModel("Aggregation")} to use this model
 */
class Aggregation extends GraphandModel_1.default {
    /**
     * Execute aggregation by id
     * @param _id {string} - Id of aggregation
     * @param vars {Object=} - Values sent to api (used as params for target aggregation)
     */
    static execute(_id, vars) {
        return new AggregationExecutor_1.default({ _id, vars, client: this._client });
    }
    /**
     * Execute current aggregation
     * @param vars {Object=} - Values sent to api (used as params for target aggregation)
     */
    execute(vars) {
        const client = this instanceof GraphandModelPromise_1.default ? this.model._client : Object.getPrototypeOf(this).constructor._client;
        return new AggregationExecutor_1.default({ _id: this._id, vars, client });
    }
}
Aggregation._customFields = {};
Aggregation.apiIdentifier = "aggregations";
Aggregation.baseUrl = "/aggregations";
Aggregation.scope = model_scopes_1.default.Aggregation;
Aggregation.envScope = model_env_scopes_1.default.ENV;
Aggregation.schema = {
    name: new GraphandFieldText_1.default(),
    description: new GraphandFieldText_1.default(),
    scope: new GraphandFieldScope_1.default(),
    pipeline: new GraphandFieldJSON_1.default({ defaultValue: [] }),
    defaultVars: new GraphandFieldJSON_1.default(),
    cache: new GraphandFieldBoolean_1.default(),
    cacheExpiredToleration: new GraphandFieldBoolean_1.default(),
    cacheMaxAge: new GraphandFieldNumber_1.default(),
    cacheKey: new GraphandFieldJSON_1.default({
        fields: {
            scope: new GraphandFieldScope_1.default(),
            conditions: new GraphandFieldJSON_1.default(),
        },
    }),
};
Aggregation._promiseAvailableMethods = ["execute"];
exports.default = Aggregation;
